var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.24 223.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#020288;stroke-miterlimit:10;}.cls-1,.cls-4{stroke-width:9.82px;}.cls-2{stroke-width:7.9px;}.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-3{stroke-width:10px;}.cls-6{fill:#69fbc2;}.cls-5{stroke-width:10.46px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.72,
    y: 87.2,
    width: 222.8,
    height: 131.81,
    rx: 10.96,
    ry: 10.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.23,
    y: 54.04,
    width: 243.78,
    height: 31.75,
    rx: 10.96,
    ry: 10.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m67.21,21.16h117.26c6.05,0,10.96,4.91,10.96,10.96v20.79H56.25v-20.79c0-6.05,4.91-10.96,10.96-10.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.86,
    y: 5,
    width: 42.52,
    height: 18.43,
    rx: 9.21,
    ry: 9.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.23,54.47h33.45v33.17c0,9.23-7.49,16.72-16.72,16.72h0c-9.23,0-16.72-7.49-16.72-16.72v-33.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m178.99,54.47h33.45v33.17c0,9.23-7.49,16.72-16.72,16.72h0c-9.23,0-16.72-7.49-16.72-16.72v-33.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m119.27,168.47c-.53,4.12-.41,7.99-1.62,11.4-1.36,3.85-3.59,7.5-6.01,10.82-2.11,2.88-5.62,2.88-8.07.76-2.41-2.08-2.73-5.54-.36-8.14,3.73-4.07,4.5-8.85,4.21-14.06-.09-1.67-.77-2.32-2.43-2.41-5.21-.3-9.99.47-14.05,4.22-2.59,2.39-6.09,2.05-8.13-.36-2.14-2.53-1.9-5.61.7-8.16,4.88-4.79,10.9-6.78,17.59-7.09,1.42-.07,2.84,0,4.64,0-.16-8.48,1.22-16.36,7.45-22.64,6.25-6.3,14-8.07,22.66-7.65.26-3.06.4-5.97.78-8.85.66-5.06,2.83-9.45,6.31-13.18,2.72-2.92,6.05-3.25,8.58-.94,2.39,2.18,2.52,5.6,0,8.39-3.72,4.1-4.35,8.97-3.82,14.13.07.71,1.15,1.8,1.86,1.87,5.16.54,10.03-.09,14.14-3.8,2.81-2.53,6.21-2.42,8.39-.03,2.32,2.54,1.98,5.87-.9,8.58-4.9,4.6-10.85,6.51-17.43,6.79-1.41.06-2.82,0-4.55,0,.26,8.64-1.26,16.48-7.51,22.74-6.26,6.27-14.06,7.89-22.4,7.61Zm18.07-20.82c.11-3.39.29-6.37.23-9.35-.01-.57-.96-1.58-1.49-1.59-3.04-.06-6.09.12-9.46.24,3.73,3.73,6.93,6.91,10.73,10.71Zm-9.37,9c-3.57-3.65-6.74-6.9-10.37-10.61-.09,3.28-.26,6.33-.18,9.37.01.52,1.04,1.44,1.62,1.45,2.96.06,5.93-.12,8.94-.22Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTools);
export default __webpack_public_path__ + "static/media/icon-tools.6b81e3a2b6ad000db8ec89bce14a2caf.svg";
export { ForwardRef as ReactComponent };